import React from "react";
import useStore from "../../zustandstore";



import moment from "moment";
import { splitCalendarSlots } from "../../utils/calendarSlots";

import InputField from "../../global/ui/InputField";
import { apiConstants } from "../../utils/constants/apiConstants";
import { STRING_CONSTANTS } from "../../utils/constants/stringConstants";

const ScheduleTime = (props) => {
  const {
    getValues,
    setValue,
    control,
    errors,
    selectedIndex,
    setSelectedIndex,
    timingError,
  } = props;

  //fetching location_id from store
  const {
    selectedDate,
    setSelectedTime,
    setBookingDuration,
    selectedServices,
    timing,
    timezone_id,
  } = useStore((state: any) => state);
  const _bookingDuration = useStore((state: any) => state.bookingDuration);

  if (getValues(apiConstants.location) === "mbl_booking") {
    setValue(apiConstants.timezone, timezone_id);
  }
  let fallBackTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const timezoneToUse = !timezone_id ? fallBackTimezone : timezone_id;

  const grouped = splitCalendarSlots(timing, timezoneToUse);
  const morning = grouped.morning;
  const evening = grouped.evening;

  const setTiming = (timings: string) => {
    setValue(apiConstants.time, timings);
  };

  let temp = new Date(selectedDate);
  const dateString = moment(temp);

  //Handle Booking Duration
  const handleBookingDuration = (start) => {
    const totalDuration = selectedServices
      .map((item) => item.duration)
      .reduce((acc, curr) => acc + curr);

    setBookingDuration(start, totalDuration);
  };

  return (
    <>
      {timingError ? (
        ""
      ) : (
        <div className="timings">
          <span>
            {STRING_CONSTANTS.available_time}{" "}
            {dateString && <span>{dateString.format("Do MMMM")}</span>}
          </span>
          <div className="morning">
            <InputField
              name={apiConstants.time}
              type="text"
              className="input-hidden"
              // errors={errors}
              control={control}
            />
            {errors?.[apiConstants.time] ? (
              <p className="text-danger">
                {errors[apiConstants.time]?.message}
              </p>
            ) : null}
            <span>Morning</span>
            <ul>
              {morning.map((item) => (
                <li
                  key={item.slot}
                  className={`my-element ${
                    selectedIndex === item.slot ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedIndex(item.slot);
                    handleBookingDuration(item.label);
                    setSelectedTime(item.label);
                    setTiming(item.label);
                  }}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </div>
          <div className="morning">
            <span>Afternoon /Evening</span>

            <ul>
              {evening.map((item) => (
                <li
                  key={item.slot}
                  className={`my-element ${
                    selectedIndex === item.slot ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedIndex(item.slot);
                    setSelectedTime(item.label);
                    setTiming(item.label);
                    handleBookingDuration(item.label);
                  }}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default ScheduleTime;
